import { render, staticRenderFns } from "./ShareIos.vue?vue&type=template&id=0efe7616&"
import script from "./ShareIos.vue?vue&type=script&lang=js&"
export * from "./ShareIos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports